import {getStoreDetailFetch} from '@/api/storeApi'

/**
 * 门店相关
 */
const appstore = {
  state: {
    currentShop:{}
  },

  mutations: {
    SET_SHOP_INFO: (state, currentShop) => {
      state.currentShop = currentShop
    },
  },

  actions: {
    // 根据选择门店那里传来的门店id再请求门店详情信息
    GetShopInfo({commit}, shopInfo) {
      return new Promise((resolve, reject) => {
        let params = {
          storeId: shopInfo.storeId
        };
        getStoreDetailFetch(params).then(res => {
            console.log('获取门店详情成功', res);
            commit('SET_SHOP_INFO', res.data)
            resolve(res);
        }).catch(err => {
          console.log('获取门店详情失败', err);
          ap.alert({
            title: '错误提示',
            content: '获取门店详情失败，请检查网络或者稍后重试'
          });
          reject(err)
        })
      })
    }
  }
}

export default appstore



// WEBPACK FOOTER //
// ./src/store/modules/appstore.js